import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { GuestGuard } from '@/auth/guard';
import AuthClassicLayout from '@/layouts/auth/classic';
import { SplashScreen } from '@/components/feedback/loading-screen';
import { JwtLoginPage, JwtRegisterPage, ResetPasswordPage } from './imports';

export const jwtRoutes = [
  {
    path: 'jwt',
    element: (
      <GuestGuard>
        <AuthClassicLayout>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </AuthClassicLayout>
      </GuestGuard>
    ),
    children: [
      {
        path: 'login',
        element: <JwtLoginPage />,
      },
      {
        path: 'reset-password/:resetToken',
        element: <ResetPasswordPage />,
      },
      {
        path: 'register',
        element: <JwtRegisterPage />,
      },
    ],
  },
];
